
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/[[...param]]",
      function () {
        return require("private-next-pages/airlines/[[...param]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/[[...param]]"])
      });
    }
  